import { RequestBuilder } from '../request_builder'

export class DataRequestBuider extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'data'
  }

  enums () {
    this.filters.push('enums')
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/data_request_builder.js